import _ from "underscore";
import update from "immutability-helper";
import Log from "../../Log";
import alt from '../alt';
import NavigationActions from './NavigationActions';

class NavigationStore {
	constructor() {
		this.state = {
			location: null,
			stack: []
		};
		this.bindActions(NavigationActions);

		this.exportPublicMethods({
			isHistoryEmpty: this.isHistoryEmpty,
			getHistory: this.getHistory
		});
	}

	onUpdateLocation(location) {
		let newStack = null;
		switch (location.action) {
            case "REPLACE":
                newStack = update(this.state.stack, {$splice: [[this.state.stack.length-1, 1, location]]});
                break;
			case "POP":
                // Find stack item based by unique location.key:
                let pos = _.findLastIndex(this.state.stack, {key: location.key, basename: location.basename, pathname: location.pathname, hash: location.hash});
                if (pos >= 0) {
                    newStack = update(this.state.stack, {$splice: [[pos, this.state.stack.length, location]]});
                    break;
				}
                // Something is possibly wrong?
                if (this.state.stack.location != null) Log.debug("Received history POP without corresponding location item in the history stack");
                // Performing PUSH action:
			case "PUSH":
            default:
                newStack = update(this.state.stack, {$push: [location]});
				break;
		}
		if (newStack.length > 100) newStack = update(newStack, {$splice:[[0, 1]]});
		this.setState({
			location: location,
			stack: newStack
		});
	}

	isHistoryEmpty() {
		let state = this.getState();
		return state.stack.length == 0;
	}

	getHistory() {
        let state = this.getState();
		return state.stack;
	}
}

export default alt.createStore(NavigationStore, 'NavigationStore');
